import { Tag } from 'antd';
import { styled } from 'styled-components';
import { useState } from 'react';
import WizrText from './WizrText';
import { text } from 'stream/consumers';

interface IWizrTag {
  data: string[];
  checkable?: boolean;
  onClick?: any;
  background?: any;
  type?:any;
  borderradius?:any
  textColor?: any
  marginTop?: any
  textType?:any
  padding?:any
  checkedValue?:any
  style?:any
  width?:any
  border?: any
}

const { CheckableTag } = Tag;

const StyledTags = styled(CheckableTag)<{ background?: any,borderradius?:any, marginTop?: any ,padding?:any, checkable?: any,width?:any, border?: any}>`
  border-radius:${(p) => (p.borderradius ? p.borderradius : '16px')};
  border: ${(p) => (
    p.border
      ? p.border
      : p.background
        ? '0px solid transparent'
        : p.checked
          ? '0px solid transparent'
          : '1px solid #000'
  )};
  padding:${(p) => (p.padding ? p.padding : '5px')};
  margin-top: ${(p) => (p.marginTop ? p.marginTop : '5px')};
  background-color: ${(p) => (
    p.background ? p.background : p.checked ? '#000000' : 'transparent'
  )};
  &:hover {
    background-color: ${(p) => (
      p.background ? p.background : p.checked ? '#000000' : 'transparent'
    )};
  }
  width:${(p) => (p.width ? p.width : 'auto')};
`;

const WizrTag = ({ data, checkable, onClick, background ,type,borderradius, textColor, marginTop,textType='caption',padding='3px 11px',checkedValue,style,width, border}: IWizrTag,): JSX.Element => {
  const [checked, setChecked] = useState<any>(checkedValue !== undefined && checkedValue !== null ? checkedValue : "");
  const colors=["#DCFCE7","#FEF3C7","#FEE2E2"]
  //const colorIndex=0

  const handleTagChange = (key: number) => {    
    if(checkable){
      setChecked(key);
    }
    if (onClick) {
      onClick(data[key]);
    }
  };  

  
  

  return (
    <>
    
      {data &&
        data.length > 0 &&
        data.map((item, key) => {          
          const colorIndex = key % colors.length;  
          return (
            <StyledTags
              key={key}
              checked={type === "colorfull" ? false : checkable ? checked === key : true}
              onClick={() => handleTagChange(key)}
              background={type ==="colorfull" ? colors[colorIndex] : (checked === key) ? '#000' : background}
              borderradius={borderradius}
              marginTop={marginTop}
              padding={padding}
              style={style}
              width={width}
              border={border}
            >
              <WizrText type={textType} textColor={type === "colorfull" ? "#1D1F22" : !checkable ? textColor ? textColor : '#FFF' : checked === key ? '#FFF' : '#000' }>
                {item}
              </WizrText>
            </StyledTags>
          );
        })}
    </>
  );
};

export default WizrTag;
